import React from 'react';
import * as MUI from '@material-ui/lab';
import cn from 'classnames';
import { useStyles } from './styles';
import ExpandPolygonIcon from '../../../../../../icons/ExpandPolygon';

export const SubcategoryTitle = ({ children, ...props }) => {
  const items = props.items as React.ReactNode[] | undefined;
  const classes = useStyles(props);
  const { parent } = props;
  const expanded = parent.expanded;
  const classNameIcon = cn(classes.icon, {
    'rotate': expanded
  });
  const Label = () => (<>
    <ExpandPolygonIcon className={classNameIcon} />
    {children && `${children}`}
  </>);
  return <MUI.TreeItem nodeId="root" label={<Label />} className={classes.title} classes={classes}>
    {items}
  </MUI.TreeItem>
}

SubcategoryTitle.defaultProps = {
  role: 'subcategory-title'
}

export default SubcategoryTitle;
